// Icons
const list = [
  {
    name: "Dashboard",
    for: ["ADMIN", "DISPATCHER", "ACCOUNT MANAGER", "SUB COMPANY"],
    //icon: Dashboard,
    isCollapsible: false,
    open: false,
    src: "/assets/images/sidebarnewicons/dashboard.png",
    link: "/dashboard",
    active: false,
  },
  {
    name: "Demo Account",
    for: ["ADMIN"],
    //icon: Dashboard,
    isCollapsible: false,
    open: false,
    src: "/assets/images/sidebarnewicons/demoaccount.png",
    link: "/demoaccount",
    active: false,
    hideForDemoAccount: true
  },
  {
    name: "Zone Management",
    for: ["ADMIN"],
    //icon: Public,
    isCollapsible: true,
    open: false,
    src: "/assets/images/sidebarnewicons/geofencing.png",
    active: false,
    subMenu: [
      { name: "Add Location", for: ["ADMIN"], /*icon : AddLocation ,*/  src: "/assets/images/sidebarnewicons/addlocation.png", subLink: "/add-location" },
      { name: "List Location", for: ["ADMIN"],/*icon : List ,*/ src: "/assets/images/sidebarnewicons/listlocation.png", subLink: "/list-location" },
      { name: "Restrict Location", for: ["ADMIN"],/*icon : WrongLocation ,*/  src: "/assets/images/sidebarnewicons/restriclocation.png", subLink: "/restrict-location" },
    ],
  },
  {
    name: "Members",
    for: ["ADMIN", "SUB COMPANY"],
    // icon: Diversity3,
    isCollapsible: true,
    open: false,
    src: "/assets/images/sidebarnewicons/members.png",
    active: false,
    subMenu: [
      { name: "Passenger", for: ["ADMIN", "DISPATCHER"], /*icon: Hail,*/  src: "/assets/images/sidebarnewicons/passenger.png", subLink: "/passenger" },
      { name: "Driver", for: ["ADMIN", "DISPATCHER", "SUB COMPANY"],/*icon: SensorOccupied,*/   src: "/assets/images/sidebarnewicons/driver.png", subLink: "/driver" },
      { name: "Dispatcher", for: ["ADMIN"],/*icon: SupportAgent,*/  src: "/assets/images/sidebarnewicons/despatcher.png", subLink: "/dispatcher" },
      { name: "Sub Company", for: ["ADMIN"], /*icon: MeetingRoom ,*/  src: "/assets/images/sidebarnewicons/subcompany.png", subLink: "/sub-company" },
      { name: "Account Manager", for: ["ADMIN"], /*icon: AdminPanelSettings ,*/  src: "/assets/images/sidebarnewicons/accountmanager.png", subLink: "/account-manager" },
      { name: "Corporate", for: ["ADMIN"], /*icon: CorporateFare ,*/ src: "/assets/images/sidebarnewicons/corporate.png", subLink: "/corporate" },
      { name: "Hotel/Restaurant", for: ["ADMIN"], /*icon: Luggage ,*/  src: "/assets/images/sidebarnewicons/hotelrestaurant.png", subLink: "/hotel" },
      { name: "Customer Care", for: ["ADMIN"], /*icon: HeadsetMic ,*/  src: "/assets/images/sidebarnewicons/customercare.png", subLink: "/customer-care" },
      // { name: "Payroll", for:["ADMIN"], /*icon: Receipt ,*/ src: "/assets/images/sidebarnewicons/Payroll.png", subLink: "#" },
      // { name: "Sub Admin", for:["ADMIN"], /*icon: SupervisorAccount,*/ src: "/assets/images/sidebarnewicons/Sub Admin.png", subLink: "#" },
    ],
  },

  // {
  //   name: "Quotation Trip",
  //   isCollapsible: false,
  //  for:["ADMIN"],
  //   icon: ModeOfTravel, 
  //   open: false,
  //   src: "/assets/images/sidebarnewicons/Quotation  trip.png",
  //   link: "#",
  //   active: false,
  // },

  {
    name: "Reports",
    isCollapsible: true,
    open: false,
    src: "/assets/images/sidebarnewicons/reports.png",
    for: ["ADMIN", "ACCOUNT MANAGER"],
    // icon: Report, 
    active: false,
    subMenu: [
      { name: "Overall Ride Statement", for: ["ADMIN", "ACCOUNT MANAGER"], /*icon: Assessment ,*/  src: "/assets/images/sidebarnewicons/overallride.png", subLink: "/overallreport" },
      { name: "Daily Statement", for: ["ADMIN"], /*icon: TextSnippet ,*/  src: "/assets/images/sidebarnewicons/dailystatement.png", subLink: "/dailyreport" },
      { name: "Monthly Statement", for: ["ADMIN"], /*icon:CalendarMonth ,*/ src: "/assets/images/sidebarnewicons/monthlystatement.png", subLink: "/monthlyreport" },
      { name: "Yearly Statement", for: ["ADMIN"], /*icon: DateRange ,*/  src: "/assets/images/sidebarnewicons/yearlystatement.png", subLink: "/yearlyreport" },
      { name: "Drivers Statement", for: ["ADMIN", "ACCOUNT MANAGER"], /*icon: Description ,*/  src: "/assets/images/sidebarnewicons/driverstatement.png", subLink: "/driversreport" },
      { name: "Km Driven / Duration", for: ["ADMIN", "ACCOUNT MANAGER"], /*icon: Description ,*/  src: "/assets/images/sidebarnewicons/kmdrivenstatement.png", subLink: "/kmdriven-duration-report" },
      // { name: "Driver Account Statement", for:["ADMIN"], /*icon: AccountBox ,*/  src: "/assets/images/sidebarnewicons/Driver Account Statement.png", subLink: "#" },
      // { name: "Corporate Invoice", for:["ADMIN"], /*icon: InsertDriveFile ,*/ src: "/assets/images/sidebarnewicons/Corporate Invoice.png", subLink: "#" },
      // { name: "Sub Company Invoice",/*icon: InsertDriveFile,*/  src: "/assets/images/sidebarnewicons/Sub-company Invoice.png", subLink: "#" },
      // { name: "Hotel Invoice",/*icon: InsertDriveFile,*/ src: "/assets/images/sidebarnewicons/HOtel Invoice.png", subLink: "#" },
      // { name: "Expense Report", for:["ADMIN"], /*icon: Money ,*/src: "/assets/images/sidebarnewicons/Expensive Report.png", subLink: "#" },
    ],
  },

  {
    name: "Ratings & Reviews",
    for: ["ADMIN"],
    // icon: Reviews,
    isCollapsible: true,
    open: false,
    src: "/assets/images/sidebarnewicons/ratingsandreview.png",
    active: false,
    subMenu: [
      { name: "User Ratings", for: ["ADMIN"], /*icon: StarHalf ,*/ src: "/assets/images/sidebarnewicons/userrating.png", subLink: "/userratings" },
      { name: "Driver Ratings", for: ["ADMIN"], /*icon: StarHalf ,*/ src: "/assets/images/sidebarnewicons/drivingrating.png", subLink: "/driverratings" },
    ],
  },

  {
    name: "Notification",
    for: ["ADMIN"],
    //icon: NotificationsActive, 
    isCollapsible: true,
    open: false,
    src: "/assets/images/sidebarnewicons/notification.png",
    active: false,
    subMenu: [
      { name: "SMS Notification", for: ["ADMIN"], /*icon: Sms ,*/  src: "/assets/images/sidebarnewicons/smsnotification.png", subLink: "/smsnotifications" },
      { name: "Mail Notification", for: ["ADMIN"], /*icon: MarkEmailUnread,*/  src: "/assets/images/sidebarnewicons/mailnotification.png", subLink: "/mailnotifications" },
      { name: "Push Notification", for: ["ADMIN"], /*icon: Send ,*/  src: "/assets/images/sidebarnewicons/pushnotification.png", subLink: "/pushnotifications" },
    ],
  },

  {
    name: "Service Type",
    for: ["ADMIN"],
    // icon: LocalTaxi,
    isCollapsible: false,
    open: false,
    src: "/assets/images/sidebarnewicons/vehicletypeicon.png",
    link: "/servicetype",
    active: false,
  },


	{
    name: "Customer Care Portal",
    for:["ADMIN", "CUSTOMER CARE"],
   // icon: LocalTaxi,
    isCollapsible: false,
    open: false,
    src: "/assets/images/sidebarnewicons/customercareportel.png",
    link: "/customer-care-portal",
    active: false,
  },

  {
    name: "Fare Management",
    for: ["ADMIN"],
    //icon: Sell , 
    isCollapsible: true,
    open: false,
    src: "/assets/images/sidebarnewicons/faremanagement.png",
    active: false,
    subMenu: [
      { name: "Service Type Fare", for: ["ADMIN"], /*icon: EmojiTransportation ,*/  src: "/assets/images/sidebarnewicons/servicetypefare.png", subLink: "/servicetypefare" },
      { name: "Location-wise fare", for: ["ADMIN"], /*icon: NearMe ,*/ src: "/assets/images/sidebarnewicons/locationwisefare.png", subLink: "/ServicetypeZonefare" },
      { name: "Airport Transfer", for: ["ADMIN"], /*icon: ConnectingAirports,*/  src: "/assets/images/sidebarnewicons/airporttranswerfare.png", subLink: "/airportfare" },
      { name: "Hourly fare", for: ["ADMIN"], /*icon: ConnectingAirports,*/  src: "/assets/images/sidebarnewicons/hourlyfare.png", subLink: "/hourlyfare" },
      { name: "City wise fare", for: ["ADMIN"], /*icon: ConnectingAirports,*/  src: "/assets/images/sidebarnewicons/citywisefare.png", subLink: "/cityservicetypefare" },
      // { name: "Fare Discount", for:["ADMIN"], /*icon: Discount  , */ src: "/assets/images/sidebarnewicons/Fare Discount.png", subLink: "#" },
    ],
  },

  // {
  //   name: "Expenses Info",
  //  for:["ADMIN"],
  //icon: Info, 
  //   isCollapsible: true,
  //   open: false,
  //   src: "/assets/images/sidebarnewicons/Expenses Info.png",
  //   active: false,
  //   subMenu: [
  //     { name: "Fuel", for:["ADMIN"], /*icon: LocalGasStation,*/ src: "/assets/images/sidebarnewicons/Fuel.png", subLink: "#" },
  //     { name: "Food", for:["ADMIN"], /*icon: FoodBank ,*/ src: "/assets/images/sidebarnewicons/Food.png", subLink: "#" },
  //     { name: "Beverage", for:["ADMIN"], /*icon: LocalCafe , */ src: "/assets/images/sidebarnewicons/Beverages.png", subLink: "#" },
  //     { name: "Car Freshner", for:["ADMIN"], /*icon: Spa, */ src: "/assets/images/sidebarnewicons/Car freshener.png", subLink: "#" },
  //     { name: "Car Accessories", for:["ADMIN"], /*icon: Construction ,*/  src: "/assets/images/sidebarnewicons/Car Accessories.png", subLink: "#" },
  //   ],
  // },

  {
    name: "Earnings and Rewards",
    for: ["ADMIN"],
    //icon: Wallet, 
    isCollapsible: true,
    open: false,
    src: "/assets/images/sidebarnewicons/earningsandreward.png",
    active: false,
    subMenu: [
      //   { name: "Driver Rewards", for:["ADMIN"], /*icon: AccountBalanceWallet ,*/  src: "/assets/images/sidebarnewicons/Driver Reward.png", subLink: "/driver-rewards" },
      { name: "Driver Earnings", for: ["ADMIN"], /*icon: AccountBalanceWallet ,*/  src: "/assets/images/sidebarnewicons/driverearning.png", subLink: "/driver-earnings" },
      { name: "Driver Pending Cashouts", for: ["ADMIN"], /*icon: AccountBalanceWallet ,*/  src: "/assets/images/sidebarnewicons/driverpendingcashout.png", subLink: "/cashoutrecords" },
      { name: "Driver Approved Cashouts", for: ["ADMIN"], /*icon: AccountBalanceWallet ,*/  src: "/assets/images/sidebarnewicons/approvedcashout.png", subLink: "/cashoutsapproved" },
      { name: "Driver Rejected Cashouts", for: ["ADMIN"], /*icon: AccountBalanceWallet ,*/  src: "/assets/images/sidebarnewicons/rejectcashout.png", subLink: "/cashoutsrejected" }
      //    { name: "Cashout Sheets", for:["ADMIN"], /*icon: AccountBalanceWallet ,*/  src: "/assets/images/sidebarnewicons/Cashout Sheet.png", subLink: "/cashoutsheets" },
      //  { name: "Hotel Wallet", for:["ADMIN"], /*icon: AccountBalanceWallet ,*/   src: "/assets/images/sidebarnewicons/User Wallet.png", subLink: "#" },
    ],
  },

  {
    name: "Wallet Management",
    for: ["ADMIN"],
    //icon: Wallet, 
    isCollapsible: true,
    open: false,
    src: "/assets/images/sidebarnewicons/walletmanagement.png",
    active: false,
    subMenu: [
      { name: "User Wallet", for: ["ADMIN"], /*icon: AccountBalanceWallet ,*/  src: "/assets/images/sidebarnewicons/userwallet.png", subLink: "/user-wallet" },
      // { name: "User Rewards Settings", for:["ADMIN"], /*icon:Password ,*/ src: "/assets/images/sidebarnewicons/User reward setting.png", subLink: "/user-reward-settings" },
      //  { name: "Driver Wallet", for:["ADMIN"], /*icon: AccountBalanceWallet ,*/  src: "/assets/images/sidebarnewicons/Driver Wallet.png", subLink: "/driver-wallet" },
      //  { name: "Hotel Wallet", for:["ADMIN"], /*icon: AccountBalanceWallet ,*/   src: "/assets/images/sidebarnewicons/User Wallet.png", subLink: "#" },
    ],
  },

  // {
  //   name: "Documents",
  //  for:["ADMIN"],
  //  //icon: DocumentScanner,
  //   isCollapsible: true,
  //   open: false,
  //   src: "/assets/images/sidebarnewicons/Documents.png",
  //   active: false,
  //   subMenu: [
  //     { name: "Driver Documents", for:["ADMIN"], /*icon: DocumentScanner,*/ src: "/assets/images/sidebarnewicons/Driver Document.png", subLink: "#" }
  //   ],
  // },

  {
    name: "Marketing",
    isCollapsible: true,
    for: ["ADMIN"],
    //icon: Storefront,
    open: false,
    src: "/assets/images/sidebarnewicons/marketing.png",
    active: false,
    subMenu: [
      { name: "Promo code", for: ["ADMIN"], /*icon:Key ,*/  src: "/assets/images/sidebarnewicons/promocode.png", subLink: "/promocodes" },
      { name: "Refer & Earn", for: ["ADMIN"], /*icon: Handshake ,*/ src: "/assets/images/sidebarnewicons/referandearn.png", subLink: "/referandearn" },
      // { name: "Loyalty", for:["ADMIN"], /*icon: Loyalty,*/src: "/assets/images/sidebarnewicons/Loyalty.png", subLink: "#" },
    ],
  },

  // {
  //   name: "Customer Care Portal",
  //   isCollapsible: false,
  //  for:["ADMIN"],
  //icon: SupportAgent ,
  //   link: "#",
  //   open: false,
  //   src: "/assets/images/sidebarnewicons/Customer Care.png",
  //   active: false,
  // },
  // {
  //   name: "Bank Settings",
  //   isCollapsible: true,
  //   for:["ADMIN"],
  //   // icon: Settings ,
  //   open: false,
  //   src: "/assets/images/sidebarnewicons/banksettings.png",
  //   active: false,
  //   subMenu: [
  //     { name: "Banks Available", for:["ADMIN"], /*icon:Password ,*/ src: "/assets/images/sidebarnewicons/availablebank.png", subLink: "/available_banks" },
  //     { name: "Account type Settings", for:["ADMIN"], /*icon: SettingsApplications ,*/  src: "/assets/images/sidebarnewicons/accounttype.png", subLink: "/account-type-settings" },
  //            ],
  // },

  {
    name: "Settings",
    isCollapsible: true,
    for: ["ADMIN", "DISPATCHER", "ACCOUNT MANAGER"],
    // icon: Settings ,
    open: false,
    src: "/assets/images/sidebarnewicons/setting.png",
    active: false,
    subMenu: [
      { name: "Admin Commission Settings", for: ["ADMIN"], /*icon:Password ,*/ src: "/assets/images/sidebarnewicons/paymentsetting.png", subLink: "/admin-commission-settings" },
      // { name: "Banks Available", for:["ADMIN"], /*icon:Password ,*/ src: "/assets/images/sidebarnewicons/Driver platfrom Fee.png", subLink: "/available_banks" },
      { name: "Banner Template Management", for: ["ADMIN"], /*icon: SettingsApplications ,*/  src: "/assets/images/sidebarnewicons/othercontents.png", subLink: "/BannerTemplateManage" },
      { name: "Site Settings", for: ["ADMIN"], /*icon: SettingsApplications ,*/  src: "/assets/images/sidebarnewicons/sitesettings.png", subLink: "/site-settings" },
      //  { name: "Payment Settings", for:["ADMIN"], /*icon: Payments ,*/  src: "/assets/images/sidebarnewicons/Payment Settings.png", subLink: "/payment-settings" },
      { name: "Business Settings", for: ["ADMIN"], /*icon: BusinessCenter ,*/  src: "/assets/images/sidebarnewicons/businesssettings.png", subLink: "/business-settings" },
      { name: "Change Password", for: ["ADMIN", "DISPATCHER", "ACCOUNT MANAGER"], /*icon:Password ,*/ src: "/assets/images/sidebarnewicons/changepassword.png", subLink: "/change-password" },
      // { name: "Legal Settings", for:["ADMIN"], /*icon: Policy,*/  src: "/assets/images/sidebarnewicons/Legal Settings.png", subLink: "/legal-settings" },
      // Make Legal Settings itself collapsible
      {
        name: "Legal Settings",
        for: ["ADMIN"],
        isCollapsible: true,
        src: "/assets/images/sidebarnewicons/legalsetting.png",
        open: false,
        active: false,
        subMenu: [
          {
            name: "Terms & Conditions",
            for: ["ADMIN"],
            src: "/assets/images/sidebarnewicons/termsandcondiction.png",
            subLink: "/terms-conditions"
          },
          {
            name: "Privacy Policy",
            for: ["ADMIN"],
            src: "/assets/images/sidebarnewicons/privacypolicy.png",
            subLink: "/privacy-policy"
          }
        ]
      }
    ],
  },

  // {
  //   name: "CMS Settings",
  //  for:["ADMIN"],
  //  icon: AppSettingsAlt ,
  //   isCollapsible: true,
  //   open: false,
  //   src: "/assets/images/sidebarnewicons/CMS Settings.png",
  //   active: false,
  //   subMenu: [
  //     { name: "Trip Notes", for:["ADMIN"], /*icon: AirlineStops ,*/  src: "/assets/images/sidebarnewicons/Trip Notes.png", subLink: "#" },
  //     { name: "Trip Ratings", for:["ADMIN"], /*icon: ThumbsUpDown ,*/  src: "/assets/images/sidebarnewicons/Trip Ratings.png", subLink: "#" },
  //     { name: "Other Contents", for:["ADMIN"], /*icon: Comment ,*/  src: "/assets/images/sidebarnewicons/Other Contents.png", subLink: "#" },
  //   ],
  // },

  // for corporate users

  {
    name: "Dashboard",
    for: ["CORPORATE"],
    //icon: Dashboard,
    isCollapsible: false,
    open: false,
    src: "/assets/images/sidebarnewicons/dashboard.png",
    link: "/dashboard_corporate",
    active: false,
  },

  {
    name: "Groups",
    for: ["CORPORATE"],
    //icon: Dashboard,
    isCollapsible: false,
    open: false,
    src: "/assets/images/sidebarnewicons/members.png",
    link: "/corporate_group",
    active: false,
  },
  {
    name: "Employees",
    for: ["CORPORATE"],
    //icon: Dashboard,
    isCollapsible: false,
    open: false,
    src: "/assets/images/sidebarnewicons/passenger.png",
    link: "/corporate_employee",
    active: false,
  },

  {
    name: "Reports",
    isCollapsible: true,
    open: false,
    src: "/assets/images/sidebarnewicons/reports.png",
    for: ["CORPORATE"],
    // icon: Report, 
    active: false,
    subMenu: [
      { name: "Overall Ride Statements", for: ["CORPORATE"], /*icon: Assessment ,*/  src: "/assets/images/sidebarnewicons/overallride.png", subLink: "/overallreport_corp" },
      { name: "Daily Statement", for: ["CORPORATE"], /*icon: TextSnippet ,*/  src: "/assets/images/sidebarnewicons/dailystatement.png", subLink: "/dailytripreport_corp" },
      { name: "Monthly Statement", for: ["CORPORATE"], /*icon:CalendarMonth ,*/ src: "/assets/images/sidebarnewicons/monthlystatement.png", subLink: "/monthlytripreport_corp" },
      { name: "Yearly Statement", for: ["CORPORATE"], /*icon: DateRange ,*/  src: "/assets/images/sidebarnewicons/yearlystatement.png", subLink: "/yearlytripreport_corp" },
    ],
  },

  {
    name: "Sign Out",
    for: ["ADMIN", "DISPATCHER", "ACCOUNT MANAGER", "SUB COMPANY", "CORPORATE"],
    //  icon: ExitToApp,
    isCollapsible: false,
    open: false,
    src: "/assets/images/sidebarnewicons/signout.png",
    link: "#",
    active: false,
  },
];

export default list;
